import { mapActions, mapGetters, mapMutations } from "vuex";

import restoreForm from "../../../modules/restore-password/form-view/index.vue";

export default {
    name: "restore-password",
    data() {
        return {};
    },
    components: {
        restoreForm,
    },
    computed: {
        ...mapGetters({
            orderResult: "basket/orderResult",
            isOrderLoading: "payment/isOrderLoading",
            invoiceResult: "payment/invoiceResult",
            isInvoiceLoading: "payment/isInvoiceLoading",
            transactionResult: "payment/transactionResult",
            isTransactionLoading: "payment/isTransactionLoading",
        }),
    },
    methods: {
        ...mapActions({}),
        ...mapMutations({
            showPopup: `auth/CHANGE_POPUP_RESTORE_PASSWORD`,
        }),
    },
    destroyed() {},
};
